import BasicModel from "./basic_model";

export default class Movement extends BasicModel {
  renderMovement = function () {

    const s = this.context.scale;

    this.context.beginPath()
    this.context.moveTo(this.x(), this.y());

    for (const p in this.points) {
      const point = this.points[p];
      this.context.quadraticCurveTo(point[0] * s, point[1] * s, point[2] * s, point[3] * s);
    }

    this.context.stroke();

    if (this.selected) {
      for (const p in this.points) {
        const point = this.points[p];

        this.renderHighlight(point[2] * s, point[3] * s, false);
        this.renderHighlight(point[0] * s, point[1] * s, true);
      }
    }
  }

  renderHighlight = function (x, y, quad) {
    const oldFillStyle = this.context.fillStyle;
    const oldStrokeStyle = this.context.strokeStyle;

    this.context.beginPath();
    if (quad) {
      this.context.strokeStyle = "rgba(255, 0, 0, 0.8)";
    } else {
      this.context.strokeStyle = "rgba(0, 0, 255, 0.8)";
    }
    this.context.setLineDash([]);
    this.context.arc(x, y, 7, 0, 2 * Math.PI, true);
    this.context.stroke();

    this.context.fillStyle = oldFillStyle;
    this.context.strokeStyle = oldStrokeStyle;
  }

  renderArrow = function () {
    if (this.points.length === 0) {
      return
    }

    const lastPoint = this.points[this.points.length - 1];
    const headlen = 8
    const angle = Math.atan2(lastPoint[3] - lastPoint[1], lastPoint[2] - lastPoint[0]);
    const toX = lastPoint[2] * this.context.scale;
    const toY = lastPoint[3] * this.context.scale;

    this.context.beginPath();
    this.context.moveTo(toX, toY);
    this.context.lineTo(toX - headlen * Math.cos(angle - Math.PI / 6), toY - headlen * Math.sin(angle - Math.PI / 6));
    this.context.lineTo(toX - headlen * Math.cos(angle + Math.PI / 6), toY - headlen * Math.sin(angle + Math.PI / 6));
    this.context.lineTo(toX, toY);
    this.context.fill();
  }

}




